export default {
	/**
	 * Gets the validation error from the given API server response
	 * @param {object} e The server json response
	 * @param {string} key The validation key to parse
	 * @returns {string} The validation error, or an empty string if there is no error
	 */
	getServerError (e, key) {
		if (
			e !== null &&
			e.data &&
			e.data.hasOwnProperty(key)
		) {
			return Array.isArray(e.data[key]) ? e.data[key][0] : e.data[key];
		}

		return '';
	},

	/**
	 * Gets a generic server error from the given API server response.
	 * @param {object} e The server json response
	 * @returns {string|null} The generic error, only if no data exists in response.
	 */
	getGenericError (e) {
		if (e !== null && (e.data === undefined || e.data.length === 0)) {
			if (typeof e === 'string') {
				return e;
			}

			return e.message;
		}

		return null;
	}
};
